import React, { Fragment, useEffect, useState } from 'react';
import withStyles, { WithStylesProps } from 'react-jss';
import { useSelector } from 'react-redux';

import { getIsLoggedIn } from 'store/reducers/user';
import { isMobile, getUrlWithConsent } from 'util/index';
import { fallbackHeight } from './IFrame.const';

interface IFrameProps extends WithStylesProps<typeof styles> {
  source: string;
  name?: string;
  defaultHeight?: number;
  mobileHeight?: number;
  defaultMaxWidth?: number;
}

const IFrame: React.FunctionComponent<IFrameProps> = ({
  classes,
  source,
  name = null,
  defaultHeight = null,
  mobileHeight = null,
  defaultMaxWidth = null,
}) => {
  const isUserLoggedIn = useSelector(getIsLoggedIn);
  const url = getUrlWithConsent(source);
  const [src, setSrc] = useState(url);

  useEffect(() => {
    // force iFrame reload
    setSrc(null);
    setTimeout(setSrc, 50, url);
  }, [isUserLoggedIn]);

  return (
    <Fragment>
      {name && <h2>{name}</h2>}
      {src && (
        <iframe
          data-testid="iframe"
          className={classes.iframeComponent}
          style={{
            height: isMobile ? mobileHeight || fallbackHeight : defaultHeight || fallbackHeight,
            maxWidth: defaultMaxWidth,
          }}
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
          title={name}
          src={src}
        />
      )}
    </Fragment>
  );
};

const styles = {
  iframeComponent: {
    width: '100%',
    display: 'block',
    margin: '10px auto',
    border: 'none',
  },
};

export default withStyles(styles)(IFrame);
